export class AtLeastTwoRankedResultsRule {
    forSearch(dependencies) {
        const { applicationState } = dependencies;
        const rankedResultsCount = applicationState.getRankedResultsCount();
        return Promise.resolve(rankedResultsCount >= 2);
    }
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    forSitemapGenerator(filterKeyValues) {
        throw new Error('Method not implemented.');
    }
    getName() {
        return 'AtLeastTwoRankedResultsRule';
    }
}
